<template>
  <div>
    <alert />

    <div class="mb-4">
      <task-basic-info :task="task" />
    </div>

    <div class="mb-4">
      <work-process-record
        :task-id="task?.id"
        :records="task?.records ?? []"
        :show-comment="true"
        :show-delete="false"
      />
    </div>

    <v-row>
      <v-col cols="12" lg="6">
        <v-card>
          <v-card-title>{{ $t('Final Task Result') }}</v-card-title>
          <v-card-text>
            <v-form ref="finalTaskForm">
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="form.result_summary"
                    :rules="rules.result_summary"
                    :label="$t('Final result summary')"
                    hide-details="auto"
                    rows="8"
                    required
                    outlined
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-file-input
                    dense
                    v-model="form.report_upload"
                    accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif"
                    counter
                    multiple
                    show-size
                    :label="$t('Select your files')"
                    prepend-icon=""
                    append-icon="mdi-paperclip"
                    outlined
                    hide-details="auto"
                    :rules="rules.document"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip v-if="index < 2" label small>
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <div>
          <evaluation :form="form" />
        </div>
      </v-col>
    </v-row>

    <div class="text-center my-5">
      <v-btn
        color="secondary"
        :to="{ name: 'my-workings.detail', params: { id: this.id } }"
        class="mr-3"
        >{{ $t('Back to detail') }}</v-btn
      >
      <v-btn
        color="primary"
        v-if="canEdit"
        :disabled="submitted"
        @click="submit"
        >{{ $t('Submit') }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import { call, get } from 'vuex-pathify'
import WorkProcessRecord from './components/WorkProcessRecord'
import TaskBasicInfo from '@/components/TaskBasicInfo'
import Evaluation from '@/components/Evaluation'
import validation from '@utils/validation'
import jsonToFormData from 'json-form-data'
import Alert from '@components/Alert'

export default {
  components: {
    TaskBasicInfo,
    WorkProcessRecord,
    Evaluation,
    Alert
  },

  data() {
    return {
      submitted: true,
      form: {
        result_summary: '',
        report_upload: [],
        review: {
          time_management: 0,
          economic: 0,
          technical: 0,
          team_working: 0,
          creativity: 0
        }
      },
      rules: {
        result_summary: [(v) => validation.required(v)],
        document: [
          (v) => validation.accept(v),
          (v) => validation.arrayMax(v, 5),
          (v) => validation.filesize(v, 10 * 1024 * 1024)
        ]
      }
    }
  },

  computed: {
    task: get('task/task'),
    userId: get('user/id'),

    id() {
      return this.$route.params.id
    },

    canEdit() {
      const status = this.task?.status || null
      if (this.userId !== parseInt(this.task?.user_id)) {
        return false
      }
      if (status) {
        if (['pending', 'in_progress'].indexOf(status) > -1) {
          return true
        }
      }
      return false
    }
  },

  created() {
    this.getTask(this.id)
    this.submitted = false
  },

  methods: {
    getTask: call('task/getTask'),
    complete: call('task/complete'),
    hideAlert: call('alert/hide'),
    loading: call('app/setLoading'),

    async submit() {
      const valid = this.$refs.finalTaskForm.validate()
      if (!valid) {
        alert(this.$t('Please check data before submit!'))
        return false
      } else {
        let reviewError = false
        for (const key in this.form.review) {
          if (parseInt(this.form.review[key]) === 0) {
            reviewError = true
            break
          }
        }
        if (reviewError) {
          alert(this.$t('Please select your rating.'))
          return false
        }

        const formData = {
          id: this.id,
          data: jsonToFormData({
            ...this.form
          })
        }

        this.submitted = true
        this.hideAlert()
        this.loading(true)
        const status = await this.complete(formData)
        this.loading(false)
        if (!status) {
          this.submitted = false
        } else {
          this.$router.push({
            replace: true,
            name: 'my-workings.detail',
            params: { id: this.id }
          })
        }
      }
    }
  }
}
</script>
